import PreviewImages from '@/common/components/adjusterReport/previewImages/PreviewImages';
import MainLayout from '@/common/components/layouts/MainLayout';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default function () {
  return (
    <MainLayout
      title="زیان‌دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <DamagedVehicleImagesShow />
    </MainLayout>
  );
}

const DamagedVehicleImagesShow = () => {
  const { id, damagedId } = useParams();

  const { data: vehicleImages } = useQuery(
    getDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: true,
      damaged_id: +damagedId!,
      participantRoleType: 'damaged',
    }),
  );

  return (
    <Box pt={24}>
      <PreviewImages
        userType="damaged"
        images={{
          damagedImages:
            vehicleImages?.damaged_parts.map((item) => ({
              name: item.label,
              src: item.url,
              id: item.id,
              type: 'damaged',
            })) ?? [],
          vehicleImages:
            vehicleImages?.vehicle.map((item) => ({
              name: item.label,
              src: item.url,
            })) ?? [],
        }}
      />
    </Box>
  );
};
